import React from "react";
import DoctorMiniCard from "../global/DoctorMinCard";

export default function HomeRecentVisits({ visits = [], onSeeAll, onSelect }) {
  if (!visits.length) return null;

  return (
    <section className="p2-recent-section">
      <div className="p2-recent-header">
        <p className="p2-recent-title">Vizitat e fundit</p>

        {onSeeAll && (
          <button
            type="button"
            onClick={onSeeAll}
            className="p2-recent-seeall"
          >
            Shiko të gjitha
          </button>
        )}
      </div>

      <div className="p2-recent-list">
        {visits.map((v) => (
          <DoctorMiniCard
            key={v.id}
            avatarUrl={v.avatarUrl}
            initials={v.initials}
            name={v.name}
            specialty={v.specialty}
            subtitle={v.subtitle} // e.g. "Vizituar 2 javë më parë"
            actionLabel="Rezervo sërish"
            onAction={() => onSelect?.(v)}
            onClick={() => onSelect?.(v)}
          />
        ))}
      </div>
    </section>
  );
}
